import gql from "graphql-tag";

const FlightScheduleImportsConnection = gql`
  query FlightScheduleImportsConnection($first: Int, $orderBy: [[String]!]) {
    flightScheduleImportsConnection(first: $first, orderBy: $orderBy) {
      edges {
        node {
          executionStatus
          updatedAt
          id
        }
      }
    }
  }
`;

export { FlightScheduleImportsConnection };



// WEBPACK FOOTER //
// ./src/queries/FlightScheduleImportsConnectionMin.js